import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBookmarkCheck: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBookmarkCheck"><Path fillRule="evenodd" clipRule="evenodd" d="M4 22.7232V2H20V22.7232L12 18.1518L4 22.7232ZM15.9142 8.25L14.5 6.83579L11 10.3358L9.5 8.83579L8.08579 10.25L11 13.1642L15.9142 8.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBookmarkCheck;
